import { skipToken } from '@reduxjs/toolkit/query';

import { backendApi, useGetAccountInfoQuery } from 'src/api/@generated/backend-api';

import { selectSelectedAccount, selectSelectedAccountOrThrow } from 'src/state/account/selectors';
import { useAppSelector } from 'src/state/thunk-api';

export const useCustomerInfoQueryStateOrThrow = () => {
  const { userInfo } = useCustomerInfoQueryState();

  if (!userInfo) {
    throw new Error('Invalid state. User info must be present');
  }

  return { userInfo };
};

export const useCustomerInfoQueryState = () => {
  const selectedAccount = useAppSelector(selectSelectedAccount);
  const { data: userInfo, isLoading } = backendApi.endpoints.getAccountInfo.useQueryState(
    selectedAccount
      ? {
          partnerId: selectedAccount.partnerId,
          billingAccountId: selectedAccount.customerId,
        }
      : skipToken,
  );

  return { userInfo, isLoading };
};

export const useCustomerInfoQuery = () => {
  const selectedAccount = useAppSelector(selectSelectedAccountOrThrow);
  const { data: userInfo, isLoading } = useGetAccountInfoQuery({
    partnerId: selectedAccount.partnerId,
    billingAccountId: selectedAccount.customerId,
  });

  return { userInfo, isLoading };
};
